// extracted by mini-css-extract-plugin
export default {"container":"container-pBn83kjC","hidden":"hidden-oWNHwS4D","red":"red-nRYeUzWr"};